import Person from "./profile/Person";
import {Route, Routes} from "react-router-dom";
import News from "./News";
import Settings from "./settings/Settings.tsx";
import Calender from "./calender/Calender";
import Component from "./components/Component";
import ProgramPlaner from "./weekPlaner/ProgramPlaner";
import Users from "./profile/Users";
import Dashboard from "./Dashboard";
import Products from "./settings/Products.tsx";
import BoxTV from "./boxTV/BoxTV.tsx";

function header(str){
  switch(str){
    case "/":
      return ""
    case "/news":
    case "/news/":
      return "Neuigkeiten"
    case "/schedule":
    case "/schedule/":
      return "Kursplanung"
    case "/planning":
    case "/planning/":
      return "Programmplanung"
    case "/user":
    case "/user/":
      return "Mitglied"
    case "/users":
    case "/users/":
      return "Mitglieder"
    case "/settings":
    case "/settings/":
      return "Einstellungen"
    case "/user/add":
    case "/user/add/":
      return "Mitglied hinzufügen"
    case "/products":
      return "Produkte"
    case "/boxtv":
      return null
    default:
      if (str.includes("/user/")){
        if(str.includes("edit=true")){
          return "Mitglied bearbeiten";
        }
        return "Mitglied";
      }
      if (str.includes("/calendar")){
        return ""
      }
      return str
  }
}
export default function MainMenu({setToken}){

  // const [ego, setEgo] = useState(false);
  // const [persons, setPersons] = useState(false);

  function handleLogout(){
    localStorage.removeItem("token");
    setToken(null);
  }

  return (
    <div className="maincontent">
      <h1>{header(window.location.pathname+window.location.search)}</h1>
      <Routes>
        <Route path="/" element={<Dashboard/>}/>
        <Route path="/news" element={<News/>}/>
        <Route path="/user" element={<Person/>}/>
        <Route path="/user/:id" element={<Person/>}/>
        <Route path="/users" element={<Users/>}/>
        <Route path="/schedule" element={<Calender isSchedulePlaner={true}/>}/>
        <Route path="/planning" element={<Calender isSchedulePlaner={false}/>}/>
        <Route path="/calendar" element={<Calender isSchedulePlaner={null}/>}/>
        <Route path="/component" element={<Component/>}/>
        <Route path="/program" element={<ProgramPlaner/>}/>
        <Route path="/settings" element={<Settings/>}/>
        <Route path="/products" element={<Products/>}/>
        <Route path="/boxtv" element={<BoxTV/>}/>
      </Routes>
    </div>

  );
}


